import React, { useState } from "react";
import PropTypes from "prop-types";

import { useQuery, useApolloClient } from "react-apollo";
import gql from "graphql-tag";

import { Button, Icon } from "rbx";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { ALL_DIRECTIONS_QUERY } from "../../graphql/Directions/Directions.graphql";

import { printDirections } from "../../utils/export";
import { deepFlatten, ourToast as toast } from "../../utils";

const SINGLE_ORDER_DIRECTIONS_QUERY = gql`
  query Order($where: OrderWhereUniqueInput!) {
    Order(where: $where) {
      RecId
      StartLocationRecIdRef
      PickupLocationRecIdRef
      DeliveryLocationRecIdRef
      EndingLocationRecIdRef
    }
  }
`;
const PrintOrderDirectionsButton = ({ orderRecId, handleSave, edited }) => {
  const client = useApolloClient();
  const [loading, setLoading] = useState(false);
  const {
    data: { Order = {} }
  } = useQuery(SINGLE_ORDER_DIRECTIONS_QUERY, {
    variables: {
      where: {
        RecId: orderRecId
      }
    }
  });

  const handlePrintDirections = async () => {
    setLoading(true);
    try {
      if (handleSave && edited) {
        await handleSave(null, true);
      }
      const legs = [
        {
          origin: Order.StartLocationRecIdRef,
          destination: Order.PickupLocationRecIdRef
        },
        {
          origin: Order.PickupLocationRecIdRef,
          destination: Order.DeliveryLocationRecIdRef
        },
        {
          origin: Order.DeliveryLocationRecIdRef,
          destination: Order.EndingLocationRecIdRef
        }
      ];

      const directionData = await Promise.all(
        legs.map(async (leg, index) => {
          const { data } = await client.query({
            query: ALL_DIRECTIONS_QUERY,
            variables: {
              where: {
                OriginLocationRecIdRef: leg.origin,
                DestinationLocationRecIdRef: leg.destination
              },
              orderByMulti: ["Priority_ASC"]
            }
          });
          if (!data.Directions[0]) {
            const errors = [
              "Start to Pickup",
              "Pickup to Delivery",
              "Delivery to Ending"
            ];

            toast.error(`No directions found for ${errors[index]}`);
          }
          return data.Directions;
        })
      );
      const result = deepFlatten(directionData);

      printDirections(...result);
    } catch (err) {
      toast.error("Error getting Directions.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Button
      color="link"
      size="small"
      state={loading ? "loading" : ""}
      onClick={handlePrintDirections}
    >
      <Icon>
        <FontAwesomeIcon icon="print" />
      </Icon>
      <span>Print Directions</span>
    </Button>
  );
};

PrintOrderDirectionsButton.propTypes = {
  orderRecId: PropTypes.number,
  handleSave: PropTypes.func,
  edited: PropTypes.bool
};
PrintOrderDirectionsButton.defaultProps = {
  orderRecId: 0,
  handleSave: () => null,
  edited: false
};
export default PrintOrderDirectionsButton;
